import _omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { EmployeeListResponse } from "services";

import Paths from "./paths";
import {
  GroupEmployeeListRequest,
  GroupEmployeeListResponse,
  GroupEmployee,
  GroupEmployeeCreateRequest,
  GroupEmployeeUpdateRequest,
  GroupEmployeeShortListResponse,
  GroupEmployeeListEmployeeRequest,
  GroupEmployeeAddEmployeeRequest,
  GroupEmployeeListEmployeeResponse,
  GroupEmployeeListRoleRequest,
  GroupEmployeeListRoleResponse,
  GroupEmployeeAddRoleRequest,
} from "./types";

/**
 * List
 */
export const groupEmployeeListService = (params: GroupEmployeeListRequest) =>
  RestAPIClient.call<GroupEmployeeListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const groupEmployeeListShortService = (
  params: GroupEmployeeListRequest
) =>
  RestAPIClient.call<GroupEmployeeShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const groupEmployeeDetailService = (id: number) =>
  RestAPIClient.call<GroupEmployee>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const groupEmployeeCreateService = (data: GroupEmployeeCreateRequest) =>
  RestAPIClient.call<GroupEmployee>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const groupEmployeeUpdateService = (data: GroupEmployeeUpdateRequest) =>
  RestAPIClient.call<GroupEmployee>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data: _omit(data, ["id"]),
  });

/**
 * Update status
 */
export const groupEmployeeUpdateStatusService = ({
  id,
  isActive,
}: {
  id: number;
  isActive: boolean;
}) =>
  RestAPIClient.call<GroupEmployee>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${id}/${isActive ? "active" : "inactive"}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Delete
 */
export const groupEmployeeDeleteService = (data: { id: number }) =>
  RestAPIClient.call<GroupEmployee>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * List Employee
 */

export const groupEmployeeListEmployeeService = (
  params: GroupEmployeeListEmployeeRequest
) =>
  RestAPIClient.call<GroupEmployeeListEmployeeResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${params.groupEmployeeId}/employees`,
    config: {
      requireAuthentication: true,
      params: _omit(params, ["groupEmployeeId"]),
    },
  });

/**
 * Add Employee
 */

export const groupEmployeeAddEmployeeService = (
  params: GroupEmployeeAddEmployeeRequest
) =>
  RestAPIClient.call<EmployeeListResponse>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.List}/${params.groupEmployeeId}/add-employees`,
    config: {
      requireAuthentication: true,
    },
    data: _omit(params, ["groupEmployeeId"]),
  });

/**
 * Remove Employee
 */

export const groupEmployeeRemoveEmployeeService = (
  params: GroupEmployeeAddEmployeeRequest
) =>
  RestAPIClient.call<EmployeeListResponse>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.List}/${params.groupEmployeeId}/remove-employees`,
    config: {
      requireAuthentication: true,
    },
    data: _omit(params, ["groupEmployeeId"]),
  });

/**
 * List role
 */

export const groupEmployeeListRoleService = (
  params: GroupEmployeeListRoleRequest
) =>
  RestAPIClient.call<GroupEmployeeListRoleResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${params.groupEmployeeId}/roles`,
    config: {
      requireAuthentication: true,
      params: _omit(params, ["groupEmployeeId"]),
    },
  });

/**
 * Add role
 */

export const groupEmployeeAddRoleService = (
  params: GroupEmployeeAddRoleRequest
) =>
  RestAPIClient.call<EmployeeListResponse>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.List}/${params.groupEmployeeId}/add-roles`,
    config: {
      requireAuthentication: true,
    },
    data: _omit(params, ["groupEmployeeId"]),
  });

/**
 * Remove role
 */

export const groupEmployeeRemoveRoleService = (
  params: GroupEmployeeAddRoleRequest
) =>
  RestAPIClient.call<EmployeeListResponse>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.List}/${params.groupEmployeeId}/remove-roles`,
    config: {
      requireAuthentication: true,
    },
    data: _omit(params, ["groupEmployeeId"]),
  });
